export function historyScroll() {
    let $header = $(".header");
    let parent = $(".timeline-holder");
    let $stickyEl = parent.find(".scroll-element");
    let itemsList = parent.find(".history-item");

    $(window).on("load resize scroll", attachStickyElements);

    function attachStickyElements() {
        let windowWidth = this.innerWidth;

        if (windowWidth >= 1200) {
            let scrollTop = $(this).scrollTop();
            $stickyEl.each(function (i, item) {
                let $el = $(item);
                let $stickyHolder = $el.parents(".timeline-holder");

                let elHeight = $el.innerHeight();
                let holderHeight = $stickyHolder.innerHeight();
                let holderOffset = $stickyHolder.offset();
                let holderTop = holderOffset.top;

                let headerHeight = $header.innerHeight();
                let offsetFromHeader = 40;
                let headerOffset = headerHeight + offsetFromHeader;

                let fixedStartPoint = holderTop - headerOffset;
                let fixedEndPoint = holderTop + holderHeight - elHeight - headerOffset;

                if (scrollTop >= fixedStartPoint && scrollTop < fixedEndPoint) {
                    $el.removeClass("absolute").css({
                        position: "fixed",
                        top: headerOffset,
                        left: 50 + "%",
                        bottom: "auto",
                        marginTop: 0
                    });
                } else if (scrollTop >= fixedEndPoint) {
                    $el.css({
                        position: "absolute",
                        top: "auto",
                        left: 50 + "%",
                        bottom: 0
                    });
                } else {
                    $el.removeAttr("style");
                }
            });
        } else {
            $stickyEl.removeAttr("style");
        }
        if (windowWidth < 1024) {
            itemsList.removeAttr("style");
        }
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/historyScroll.js